import { useState } from 'react';
import { UMIcon, UMR } from '../_components';
import type { UMToolSpec } from '../_components';

/**
 * Measure tools moved out of the top bar, aligned with the 2D/3D control at the bottom left.
 * Same geometry as `UMMapControls` (35×35 buttons in a bordered white group); `left` places the
 * group right after the basemap tile, the zoom group and the 2D/3D group.
 */

export const MEASURE_TOOLS: UMToolSpec[] = [
  { id: 'length', icon: 'straighten', label: 'Mesurer une longueur' },
  { id: 'erase-measure', icon: 'ink_eraser', label: 'Supprimer des mesures' },
];

const GROUP_WIDTH = UMR.size.controlButton * 2 + 2;
const LEFT = UMR.size.controlsInset + UMR.size.basemapTile + 8 + GROUP_WIDTH + 8 + GROUP_WIDTH + 8;

function MeasureButton({ tool, pressed, onClick }: { tool: UMToolSpec; pressed: boolean; onClick: () => void }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      aria-label={tool.label}
      title={tool.label}
      aria-pressed={pressed}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: UMR.size.controlButton, height: UMR.size.controlButton, border: 'none', padding: 0,
        background: pressed ? UMR.blue : hover ? UMR.hover : 'transparent',
        display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
      }}
    >
      <UMIcon name={tool.icon} size={24} color={pressed ? UMR.white : UMR.black} style={{ height: 31 }} />
    </button>
  );
}

export function MeasureControls({ activeTool, onToolChange }: { activeTool: string | null; onToolChange: (id: string | null) => void }) {
  return (
    <div
      role="group"
      aria-label="Mesures"
      style={{
        position: 'absolute', bottom: UMR.size.controlsInset, left: LEFT, zIndex: 10,
        display: 'flex', border: `1px solid ${UMR.border}`, background: UMR.white,
      }}
    >
      {MEASURE_TOOLS.map((t) => (
        <MeasureButton key={t.id} tool={t} pressed={activeTool === t.id} onClick={() => onToolChange(activeTool === t.id ? null : t.id)} />
      ))}
    </div>
  );
}
